/**
 * Main layout component following Tenant Nexus UI style guide
 */

import React from 'react';
import { Header } from './header';
import { Sidebar } from './sidebar';
import { cn } from '@/utils';

interface LayoutProps {
  children: React.ReactNode;
  className?: string;
}

export function Layout({ children, className }: LayoutProps) {
  return (
    <div className={cn('app-container', className)}>
      <Header />
      <div className="main-container">
        <Sidebar />
        <main className="content-panel">
          <div className="content-container">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}
